import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { ArrowRight, CheckCircle, Star, Wrench } from 'lucide-react';

const Hero = () => {
  return (
    <section id="inicio" className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 via-white to-red-50 overflow-hidden">
      {/* Decorative Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-72 h-72 bg-red-100/30 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-blue-100/20 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/3 w-64 h-64 bg-amber-100/20 rounded-full blur-2xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="text-center">
          {/* Badge */}
          <Badge className="mb-6 bg-red-100 text-red-800 border-red-200 px-4 py-2 text-sm font-medium">
            <Star size={16} className="mr-2" />
            Tienda profesional · Envío a todo el mundo
          </Badge>

          {/* Main Heading */}
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-slate-900 mb-6 leading-tight">
            Herramientas y Accesorios
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-600 to-red-700 block">
              Profesionales para Drywall
            </span>
          </h1>

          {/* Subtitle */}
          <p className="text-lg md:text-xl text-slate-600 mb-8 max-w-3xl mx-auto leading-relaxed">
            Más de 50 herramientas seleccionadas por expertos: medición, corte, fijación, acabado, lijado, seguridad y más.
            Compra online con pago seguro y envío a cualquier país. Además, ofrecemos diseño y asesoría de planos 100% online.
          </p>

          {/* Features List */}
          <div className="flex flex-wrap justify-center gap-6 mb-10">
            {[
              '+50 Herramientas Profesionales',
              'Envío Internacional',
              'Pago Seguro con Stripe',
              'Facturación Automática'
            ].map((feature, index) => (
              <div key={index} className="flex items-center gap-2 text-slate-700">
                <CheckCircle size={20} className="text-red-600" />
                <span className="font-medium">{feature}</span>
              </div>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link to="/tienda">
              <Button
                size="lg"
                data-testid="hero-cta-store"
                className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 text-lg font-semibold transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-red-200 group w-full sm:w-auto"
              >
                <Wrench size={20} className="mr-2 group-hover:rotate-12 transition-transform duration-200" />
                Ver Tienda de Herramientas
                <ArrowRight size={20} className="ml-2 group-hover:translate-x-1 transition-transform duration-200" />
              </Button>
            </Link>
            <Button 
              size="lg" 
              data-testid="hero-cta-packages"
              onClick={() => document.getElementById('paquetes')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-slate-900 hover:bg-slate-800 text-white px-8 py-4 text-lg font-semibold transition-all duration-300 hover:scale-105 shadow-lg group"
            >
              Paquetes de Diseño Online
              <ArrowRight size={20} className="ml-2 group-hover:translate-x-1 transition-transform duration-200" />
            </Button>
            <Button 
              variant="outline" 
              size="lg"
              data-testid="hero-cta-request"
              onClick={() => document.getElementById('solicitar')?.scrollIntoView({ behavior: 'smooth' })}
              className="px-8 py-4 text-lg font-semibold border-2 border-slate-300 hover:border-red-600 hover:text-red-600 transition-all duration-300"
            >
              Solicitar Diseño
            </Button>
          </div>

          {/* Stats */}
          <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
            {[
              { number: '500+', label: 'Proyectos Online Entregados' },
              { number: '98%', label: 'Clientes Satisfechos' },
              { number: '10+', label: 'Años de Experiencia' },
              { number: '24h', label: 'Tiempo de Respuesta' }
            ].map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-red-600 mb-2">{stat.number}</div>
                <div className="text-sm md:text-base text-slate-600">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;